import { FoundationProject } from '@models';

export interface AllProjectsResult {
  projects: FoundationProject[];
}
